export const YEARS_TO_RETIREMENT = ["1-5 Years", "5-10 Years", "10-20 Years", "20+ Years", "Retired"];
export const RELATIONSHIP_STATUS = ["Single", "Relationship", "Married", "Domestic Partnership", "Getting divorced", "Divorced", "Widowed"];
export const SPECIALIZED_DEMOGRAPHIC = [
    "Military members / veterans",
    "Special needs",
    "Caregivers",
    "LGBTQ+",
    "Underrepresented group",
    "Business owners/entrepreneurs",
    "Young families",
    "HENRYs",
];
export const GENDER_PREFERENCES = ["Male", "Female", "Non-binary", "Other", "All genders"];
export const SPECIALITY_PLANNING = [
    "Family planning including fertility planning/adoption",
    "Planning for education",
    "Inheritance",
    "Managing Debt",
    "Real estate purchase/sale",
    "Crypto",
    "Alternative Investments",
    "ESG",
];
export const SERVICE_AREAS = [
    "One time financial plans",
    "Trusts & wills",
    "Insurance",
    "Financial coaching",
    "Tax",
    "Real Estate",
    "Debt management",
    "Cash flow analysis/Budgeting",
    "Employer benefit analysis",
];
export const COMMUNICATION_PREFERENCES = ["Monthly", "Quarterly", "6 months", "Annually", "As needed"];
export const MEETING_FORMAT = ["In person", "Virtual"];
export const FEE_STRUCTURE = [
    { value: 1, label: "Flat fee hourly" },
    { value: 2, label: "Flat fee monthly" },
    { value: 3, label: "Flat fee yearly" },
    { value: 4, label: "Percentage of assets" },
    { value: 5, label: "Flexible" },
];
export const STATES = [
    "AL",
    "AK",
    "AZ",
    "AR",
    "CA",
    "CO",
    "CT",
    "DE",
    "DC",
    "FL",
    "GA",
    "HI",
    "ID",
    "IL",
    "IN",
    "IA",
    "KS",
    "KY",
    "LA",
    "ME",
    "MD",
    "MA",
    "MI",
    "MN",
    "MS",
    "MO",
    "MT",
    "NE",
    "NV",
    "NH",
    "NJ",
    "NM",
    "NY",
    "NC",
    "ND",
    "OH",
    "OK",
    "OR",
    "PA",
    "RI",
    "SC",
    "SD",
    "TN",
    "TX",
    "UT",
    "VT",
    "VA",
    "WA",
    "WV",
    "WI",
    "WY",
    "PR",
    "VI",
    "GU",
];
export const ASSET_OPTIONS = [
    { value: "0", label: "No minimum" },
    { value: "100000", label: "Minimum $100K" },
    { value: "250000", label: "Minimum $250K" },
    { value: "500000", label: "Minimum $500K" },
    { value: "1000000", label: "Minimum $1M" },
    { value: "2500000", label: "Minimum $2.5M" },
    { value: "5000000", label: "Minimum $5M" },
];